import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Error403() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-brand-navy-50 px-4">
      <SEO
        title="403 Adgang forbudt | Jan Nørgaard"
        description="Du har ikke tilladelse til at tilgå denne side hos Entreprenør Jan Nørgaard ApS."
        noindex={true}
      />
      <div className="text-center max-w-md">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-red-100 text-red-600 mb-6">
          <i className="fa-duotone fa-shield-exclamation text-4xl" />
        </div>
        <h1 className="font-display text-4xl font-bold uppercase text-brand-navy-900 tracking-tight">
          403 Adgang Forbudt
        </h1>
        <p className="mt-4 text-brand-navy-600 leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, dette er en fejl, bedes du kontakte os.
        </p>
        <div className="mt-8 flex justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded bg-brand-orange-500 px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-brand-orange-600"
          >
            <i className="fa-solid fa-house" /> Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 rounded border border-brand-navy-200 bg-white px-6 py-3 font-display text-sm font-bold uppercase tracking-wider text-brand-navy-900 transition-colors hover:bg-brand-navy-100"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  );
}
